import { css } from '@genesislcap/web-core';

export const BondBiddingStyles = css`
  :host {
    /* Add custom styles here if needed */
    --control-bar-height: 45px;
  }

  rapid-flyout::part(flyout) {
    display: flex;
    flex-direction: column;
    width: var(--flyout-width, 500px);
    min-width: 500px;
    max-width: 1000px;
    padding: 0;
    position: fixed;
    top: var(--nav-height);
    height: calc(100vh - var(--nav-height) - 15px);
    max-height: calc(100vh - var(--nav-height) - 15px);
    transition: width 0.1s ease, opacity 0.3s ease, transform 0.3s ease;
  }  

  rapid-flyout::part(header) {
    border-bottom: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-divider-rest);
  }

  rapid-flyout::part(content) {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  rapid-flyout::part(content),
  rapid-flyout::part(footer) {
    padding: 0;
  }

  tranche-detail-flyout {
    height: 100%;
  }

  ::part(title) {
    padding-left: 10px;
  }

  .bond-bidding-header {
    display: flex;
    padding: 5px;
    height: var(--control-bar-height);
    background: var(--neutral-layer-2);
  }

  .controls {
    display: flex;
    align-items: center;
    padding-left: 10px;
    width: 100%;
    gap: 10px;
    color: var(--neutral-foreground-hint);
    background: var(--neutral-layer-2);
  }

  .bond-bidding-main-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }

  .bond-bidding-grid-area {
    display: flex;
    width: 100%;
    transition: margin-left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .bond-bidding-flyout-area {
    background: var(--neutral-layer-1);
    box-shadow: var(--elevation-shadow-flyout);
    height: 100%;
    z-index: 2;
    transition:
      transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1),
      width 0.6s cubic-bezier(0.4, 0, 0.2, 1),
      min-width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    position: relative;
    transform: translateX(-100%);
    pointer-events: none;
    opacity: 0;
    width: 0;
    min-width: 0;
  }

  .bond-bidding-flyout-area.open {
    transform: translateX(0);
    pointer-events: auto;
    opacity: 1;
    width: 420px;
    min-width: 420px;
  }

  mbm-grid-pro {
    width: 100%;
    height: calc(100% - var(--control-bar-height) - 10px);
  }

  foundation-filters {
    height: calc(100% - var(--control-bar-height) - 20px);
    font-size: small;
  }

  foundation-filters > .filter-persistence-controls-container {
    padding: 15px;
  }

  foundation-filters::part(container-forms) {
    height: 100%;
    scrollbar-color: var(--neutral-stroke-rest) transparent;
  }

  rapid-label {
    font-size: var(--type-ramp-base-font-size);
  }

  rapid-text-field > rapid-button {
    background-color: color-mix(in srgb, var(--neutral-fill-input-rest), transparent 94%);
    border: unset;
  }

  rapid-text-field {
    margin-bottom: 0px;
  }

  rapid-text-field::part(end) {
    margin-inline-end: 0px;
  }

  .filter-active {
    border: 1px solid var(--accent-fill-active);
    border-radius: calc(var(--control-corner-radius) * 1px);
  }

  rapid-text-field::part(control) {
    cursor: pointer !important;
  }

  .flyout-close-row {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 15px;
    align-items: baseline;
    z-index: 10;
    position: relative;
  }

  criteria-segmented-control {
    --neutral-fill-stealth-rest: var(--accent-fill-rest);
  }

  rapid-text-field::part(root) {
    height: calc(
      (((var(--base-height-multiplier) + var(--density)) * var(--design-unit)) - 6) * 1px
    );
  }

  rapid-select {
    height: calc(
      (((var(--base-height-multiplier) + var(--density)) * var(--design-unit)) - 6) * 1px
    );
  }

  rapid-button {
    height: calc(((var(--base-height-multiplier) + var(--density)) * var(--design-unit) - 6) * 1px);
  }

  rapid-button::part(control) {
    display: flex;
    justify-content: space-between;
    align-items: center; 
  }

  .bulk-response-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .bulk-response-actions .bulk-response-btn::part(control) {
    background-color: var(--neutral-fill-rest);
    color: var(--neutral-foreground-rest);
    border-radius: calc(var(--control-corner-radius) * 1px);
    transition: background-color 0.15s ease, color 0.15s ease;
    min-width: 120px;
    padding-inline: 24px;
    justify-content: center;
  }

  .bulk-response-actions .bulk-response-btn:hover::part(control) {
    background-color: var(--accent-fill-rest);
    color: #fff;
  }

  .bulk-response-actions .bulk-response-btn:disabled::part(control),
  .bulk-response-actions .bulk-response-btn[disabled]::part(control) {
    opacity: 1;
    cursor: not-allowed;
    background-color: var(--neutral-fill-rest);
    color: var(--neutral-foreground-rest);
    font-weight: 500;
  }

  .upload-button-wrapper {
    position: relative;
    display: inline-block;
  }

  .upload-button-wrapper .upload-download-spinner {
    position: absolute;
    inset-block: 0;
    right: 8px;
    margin-block: auto;
    inline-size: 16px;
    block-size: 16px;
    pointer-events: none;
  }



  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    max-width: 140px; /* Adjust this value to leave space for the icon */
  }

  @keyframes glow {
    from {
      background-color: color-mix(in srgb, var(--accent-fill-rest) 20%, var(--neutral-fill-rest));
      
    }
    to {
      background-color: color-mix(in srgb, var(--accent-fill-rest) 100%, var(--neutral-fill-rest));
      
    }
  }
`;